import { tenantRootPath } from "../tenancy/paths";

export const DB_BOOKING_WEBSITES_REF = `booking-websites/`;

export const createBookingWebsiteDbRef = (siteId:string, path?:string) =>{
    const rootPath = tenantRootPath(siteId);
    if(path){
        if (path.startsWith('/') || path.endsWith('/') || path.split('/').some((segment) => !segment || segment === '.' || segment === '..')) {
            throw new Error('Tenant relative path is malformed.');
        }
        return `${rootPath}/${path}`
    }
    return `${rootPath}/`
}
